module.exports = __webpack_public_path__ + "img/preferences.b135aa79.jpg";